import React, { FC, useState } from 'react';
import difference from 'lodash/difference';
import uniqBy from 'lodash/uniqBy';
import { useTranslate } from '@im/react-localization';
import LoadingButton from '@mui/lab/LoadingButton';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import {
  Customer,
  useBulkCustomers,
} from 'src/views/customerGroups/hooks/customerSearchQuery';

export interface InclusionExclusionFilter {
  field: string;
  value: string;
}

export interface CustomerLookUpProps {
  onChange: (e: any) => void;
}

const CustomerLookUp: FC<CustomerLookUpProps> = ({ onChange }) => {
  const translate = useTranslate();
  const [customerNumbers, setCustomerNumbers] = useState('');
  const [lookingUp, setLookingUp] = useState(false);
  const [lookUpErrors, setLookUpErrors] = useState<any>([]);
  const getCustomers = useBulkCustomers();

  async function lookup() {
    setLookingUp(true);
    const customerNumbersArray = customerNumbers
      .split(',')
      .map((s) => s.trim());
    const lookUpResult = await getCustomers(customerNumbersArray);
    const not_found = difference(
      customerNumbersArray,
      lookUpResult.map((r: any) => r.customerNumber)
    );
    setLookingUp(false);
    setCustomerNumbers('');
    onChange({
      customers: uniqBy(lookUpResult, (c: Customer) => c.customerNumber),
      not_found,
    });
  }

  return (
    <Stack flexDirection="row" gap={1}>
      <TextField
        aria-describedby={translate('CustomerGroups.customerNumber')}
        error={!!lookUpErrors.length}
        helperText={
          !!lookUpErrors.length &&
          translate('CustomerGroups.bulkAddCustomersError', {
            count: lookUpErrors.length,
          })
        }
        id="customerGroupLookUp"
        margin="normal"
        multiline
        name="customerGroupLookUp"
        onChange={({ target: { value: _value } }) => {
          setLookUpErrors([]);
          setCustomerNumbers(_value);
        }}
        placeholder={translate('CustomerGroups.bulkAddCustomersPlaceholder')}
        rows={2}
        sx={{ marginTop: 0, width: '100%' }}
        value={lookUpErrors.length ? lookUpErrors.join(',') : customerNumbers}
      />

      <LoadingButton
        disabled={!customerNumbers.length}
        loading={lookingUp}
        onClick={lookup}
        type="button"
        variant="newOutlined"
      >
        {translate('CustomerGroups.addBulkCustomers')}
      </LoadingButton>
    </Stack>
  );
};

export default CustomerLookUp;
